<div class="main">
    <div class="loader" *ngIf="showLoader">
      <div class="load">
        <mat-spinner></mat-spinner>
      </div>
    </div>
    <div class="header">
      Advanced Search
      <i class="material-icons" (click)='closeDialog();'>clear</i>
    </div>
    <div class="section">
        <div class="filter">
            <div class="filter-title">
                <span>Location: </span>
            </div>
            <div class="filter-options" style="display: flex;
            width: 83.3%;">
                <div class="filter-content" style="max-width: 45% !important;">
                    <mat-select placeholder="Select Unit Location" [(ngModel)]="selectedUnitLocation" (selectionChange)="onLocationChange($event.value)">
                        <mat-option *ngFor="let location of units" [value]="location.id">
                            {{location.name}}
                        </mat-option>
                    </mat-select>
                </div>
            </div>
        </div>
        <div class="filter">
            <div class="filter-title">
                <span>In Range</span>
            </div>
            <div class="filter-content">
                <mat-select placeholder="Select Distance Range" [(ngModel)]="selectedRange">
                    <mat-option *ngFor="let range of rangesSelect" [value]="range.id">
                        {{range.name}}
                    </mat-option>
                </mat-select>
            </div>
        </div>

        <div class="buttons">
            <button mat-raised-button class="apply" color="primary" (click)="applyFilters()">Apply</button>
            <button mat-raised-button class="cancel" (click)="closeDialog()">Cancel</button>
        </div>
    </div>
  </div>